/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserModerationsModeratorControllerModerateMutationRequest,
  UserModerationsModeratorControllerModerateMutationResponse,
  UserModerationsModeratorControllerModerate401,
  UserModerationsModeratorControllerModerate404,
} from '../../types/UserModerationsModeratorControllerModerate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { userModerationsModeratorModerate } from '../../methods/userModerationsModeratorModerate.ts';
import { useMutation } from '@tanstack/react-query';

export const userModerationsModeratorModerateMutationKey = () =>
  [{ url: '/api/moderator/user-moderations/moderate' }] as const;

export type UserModerationsModeratorModerateMutationKey = ReturnType<
  typeof userModerationsModeratorModerateMutationKey
>;

/**
 * {@link /api/moderator/user-moderations/moderate}
 */
export function useUserModerationsModeratorModerate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UserModerationsModeratorControllerModerateMutationResponse,
      ResponseErrorConfig<
        UserModerationsModeratorControllerModerate401 | UserModerationsModeratorControllerModerate404
      >,
      { data: UserModerationsModeratorControllerModerateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<UserModerationsModeratorControllerModerateMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? userModerationsModeratorModerateMutationKey();

  return useMutation<
    UserModerationsModeratorControllerModerateMutationResponse,
    ResponseErrorConfig<UserModerationsModeratorControllerModerate401 | UserModerationsModeratorControllerModerate404>,
    { data: UserModerationsModeratorControllerModerateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return userModerationsModeratorModerate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
